/**
 * The calendar fields a pattern is rendered against.
 *
 * Plain numbers rather than a `Date`, for two reasons that both matter here: the
 * api forbids constructing one outside its `DateTimeService` (N3), and a `Date`
 * would drag a timezone into a value that has none — the day a pattern prints is
 * a calendar fact, not an instant.
 */
export interface DatePatternParts {
  year: number;
  /** 1–12, the way a human says it — not the 0–11 a `Date` reports. */
  month: number;
  day: number;
  /** 0 = Sunday, matching `Date.prototype.getDay`. */
  weekday: number;
}

/**
 * The instant every preview is drawn at: **Friday 27 March 2026**.
 *
 * Fixed rather than "now", so a screenshot taken tonight matches one taken
 * tomorrow and a spec cannot flake at midnight. The values are chosen to make
 * the choice visible: the day is **27**, so `DD/MM` and `MM/DD` cannot be
 * confused for one another, and the month is **3**, so a padded `MM` looks
 * different from a bare `M`.
 */
export const DATE_PATTERN_SAMPLE: Readonly<DatePatternParts> = Object.freeze({
  year: 2026,
  month: 3,
  day: 27,
  weekday: 5,
});
